<template>
  <div class="passfoot-box">
    <router-link class="iconbnt-item" :to="{name:'comment', query: paramInfo}">
      <div>
        <img src="@/assets/icon/icon-pinglun.png" />
      </div>
      <div>评论</div>
    </router-link>
    <!-- <div class="iconbnt-item">
      <div>
        <img src="@/assets/icon/icon-dayin.png" />
      </div>
      <div>打印</div>
    </div>-->
  </div>
</template>
<script>
export default {
  props: {
    paramInfo: {}
  }
};
</script>
<style lang="less" scoped>
.passfoot-box {
  display: flex;
  justify-content: space-around;
  margin-top: 0.2rem;
  .iconbnt-item {
    display: block;
    font-size: 0.293333rem;
    color: #666666;
    text-align: center;
    img {
      width: 0.64rem;
      height: 0.64rem;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Approval/ApprovalFoot/approvalPassFoot.vue